import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';


const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

  const navigationItems = [
    {
      label: 'คำนวณแผนภูมิ',
      labelEn: 'Chart Calculation',
      path: '/birth-data-input',
      icon: 'Calculator',
    },
    {
      label: 'ผลการวิเคราะห์',
      labelEn: 'Results Analysis',
      path: '/astrological-results',
      icon: 'FileText',
    },
  ];

  const isActive = (path) => location?.pathname === path;

  const handleNavigation = (path) => {
    navigate(path);
    setMobileMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-cosmic-midnight/95 backdrop-blur-xl border-b border-cosmic-gold/20 shadow-cosmic">
      <div className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <div className="flex-shrink-0 flex items-center group cursor-pointer" onClick={() => navigate('/birth-data-input')}>
              <div className="relative w-12 h-12 bg-gradient-gold rounded-xl flex items-center justify-center transition-all duration-300 group-hover:shadow-gold group-hover:scale-105">
                <Icon name="Star" size={28} color="#0a1128" className="animate-pulse-subtle" />
                <div className="absolute inset-0 bg-cosmic-gold rounded-xl opacity-0 group-hover:opacity-30 blur-xl transition-opacity duration-300" />
              </div>
              <div className="ml-4">
                <span className="text-2xl font-heading font-bold text-cosmic-gold">
                  ThaiAstroChart
                </span>
                <p className="text-xs text-cosmic-lightGold/70 font-thai mt-0.5">ดูดวงออนไลน์ระดับมืออาชีพ</p>
              </div>
            </div>
          </div>

          <nav className="hidden md:flex items-center space-x-2">
            {navigationItems?.map((item) => (
              <button
                key={item?.path}
                onClick={() => handleNavigation(item?.path)}
                className={`
                  relative flex items-center px-6 py-3 rounded-lg text-sm font-medium transition-all duration-300
                  ${
                    isActive(item?.path)
                      ? 'bg-gradient-gold text-cosmic-navy shadow-gold'
                      : 'text-cosmic-lightGold hover:bg-cosmic-gold/10 hover:text-cosmic-gold'
                  }
                `}
              >
                <Icon 
                  name={item?.icon} 
                  size={18} 
                  className="mr-2"
                  color={isActive(item?.path) ? '#0a1128' : 'currentColor'}
                />
                <span className="hidden lg:inline font-thai">{item?.label}</span>
                <span className="lg:hidden">{item?.labelEn}</span>
                {isActive(item?.path) && (
                  <div className="absolute inset-0 bg-cosmic-gold rounded-lg opacity-20 blur-xl" />
                )}
              </button>
            ))}
          </nav>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 rounded-lg text-cosmic-gold hover:bg-cosmic-gold/10 transition-all duration-300 hover:shadow-gold"
            aria-label="Toggle menu"
          >
            <Icon name={mobileMenuOpen ? 'X' : 'Menu'} size={24} />
          </button>
        </div>
      </div>
      {mobileMenuOpen && (
        <div className="md:hidden bg-cosmic-midnight/95 backdrop-blur-xl border-t border-cosmic-gold/20">
          <div className="px-4 py-4 space-y-2">
            {navigationItems?.map((item) => (
              <button
                key={item?.path}
                onClick={() => handleNavigation(item?.path)}
                className={`
                  w-full flex items-center px-5 py-4 rounded-lg text-sm font-medium transition-all duration-300
                  ${
                    isActive(item?.path)
                      ? 'bg-gradient-gold text-cosmic-navy shadow-gold'
                      : 'text-cosmic-lightGold hover:bg-cosmic-gold/10 hover:text-cosmic-gold'
                  }
                `}
              >
                <Icon 
                  name={item?.icon} 
                  size={22} 
                  className="mr-3"
                  color={isActive(item?.path) ? '#0a1128' : 'currentColor'}
                />
                <div className="flex flex-col items-start">
                  <span className="font-thai text-base">{item?.label}</span>
                  <span className="text-xs opacity-75 mt-0.5">{item?.labelEn}</span>
                </div>
              </button>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;